module.exports = __webpack_public_path__ + "media/images/sp/calendar/tel-b5cabff2a808d9c4263b12ce22b6ebd0.png";